module.exports = __webpack_public_path__ + "static/media/cifar_uncal.eed183f7.png";